import React, { useState } from 'react';
import TopBar from './TopBar';
import Navbar from './Navbar';
import MobileMenu from '../common/MobileMenu';

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <>
            <header className="vs-header layout2">
                <div className="sticky-wrapper position-relative">
                    <TopBar />
                    <Navbar onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
                </div>
            </header>
            <MobileMenu
                isOpen={isMobileMenuOpen}
                onClose={() => setIsMobileMenuOpen(false)}
            />
        </>
    );
};

export default Header;